angular.module('ApiUtils.ksat')
    .factory('SatelliteServiceDeleteReasonResource', function ($resource) {
        return $resource('/api/satellite/reasons/:slug', {}, {
            get: {
                params: {slug: '@slug'}
            }
        });

    });
